/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */

export default {
  state: {
    isUnsaved: false,
    routeNext: null,
    expandMap: false,
  },

  mutations: {
    SET_IS_UNSAVED(state, payload) {
      state.isUnsaved = payload;
    },
    SET_ROUTE_NEXT(state, payload) {
      state.routeNext = payload;
    },
    SET_EXPAND_MAP(state, payload) {
      state.expandMap = payload;
    },
  },

  actions: {
    toggleExpandMap({ commit, state }) {
      commit('SET_EXPAND_MAP', !state.expandMap);
    },
  },

  getters: {
    isUnsaved(state) {
      return state.isUnsaved;
    },
    routeNext(state) {
      return state.routeNext;
    },
    expandMap(state) {
      return state.expandMap;
    },
  },
};

/* eslint-enable no-param-reassign */
/* eslint-enable no-unused-vars */
